export enum PoNoteTypeCode {
  EffectiveDateChanged = 'EffDateChg',
  ApplyChange          = 'ApplyChg',
  Other                = 'Other',

  // In-flight order-changes (Phase 1) — see docs/in-flight-order-changes.md.
  CancelRequested  = 'CancelReq',
  CancelDefinitive = 'CancelDef',
}
